<template>
    <div>
        <a :href="`/files/${(file.download_only ? 'download' : 'view')}/${file.file_id}`"
            class="d-block"
            target="_blank">
            <img v-bind:src="getThumbnail()" class="img-fluid" :ref="`file-${file.file_id}`" />
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            file: {
                type: Object,
                required: true,
            }
        },

        data() {
            return {
                styles: '"border: 1px solid #ccc; max-height: 150px; overflow-y: hidden; background-color: #ffffff;"',
            }
        },

        computed: {

        },

        methods: {
            //Get the thumbnail preview
            getThumbnail(){
                //Check if thumbnail was set on the backend
                if(this.file.thumbnail)
                {
                    return this.file.thumbnail;
                }

                //Setup
                var preview = null;

                //Switch
                switch(this.file.file_extension.toLowerCase())
                {
                    case 'pdf':
                        preview = '/Images/file-type-pdf_256x256.png';
                        break;
                    case 'docx':
                    case 'doc':
                        preview = '/Images/file-type-docx_256x256.png';
                        break;
                    case 'xls':
                    case 'xlsx':
                        preview = '/Images/file-type-xlsx_256x256.png';
                        break;
                    case 'mp4':
                    case 'avi':
                    case 'mov':
                    case 'mpg':
                    case 'mpeg':
                    case 'flv':
                    case 'webm':
                    case 'mkv':
                    case 'ogv':
                    case 'wmv':
                        preview = '/Images/file-type-video_256x256.png';
                        break;
                    default:
                        //Data should be a path, not a string - we converted those
                        // $path = $this->{$imageDataName};
                        // $type = pathinfo($path, PATHINFO_EXTENSION);
                        // $data = Storage::get($path);
                        // $preview = "data:image/".$type.";base64," . base64_encode($data);
                        this.loadThumbnail();

                        //Stop here
                        return '';
                        break;
                }

                //Stop here
                return preview;

                //Set the preview
                //this.$refs['file-' + file.file_id][0].src = preview;
            },

            loadThumbnail(){
                //Send it
                this.$http.get('files/view/'+this.file.file_id, {display_type: 'fluid', thumbnail: true})
                    .then(response => {
                        //Sent the ref
                        this.$refs['file-' + this.file.file_id].src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });
            },
        },

        mounted() {

        }
    }
</script>
